export default "__VITE_ASSET__BwxyBfeC__"